const CARD_BRANDS = {
  AMEX: 'AMEX',
  DISCOVER: 'DISCOVER',
  ELECTRON: 'ELECTRON',
  ELO: 'ELO',
  MA: 'MA',
  MASTERCARD: 'MASTERCARD',
  UNKNOWN: 'UNKNOWN',
  VISA: 'VISA'
};

const CARD_TYPES = {
  CREDIT: 'CREDIT',
  DEBIT: 'DEBIT'
};
/**
 * CardBrandClass used to make card brand enums as read-only and static
 */
class CardBrandClass {
  /**
   * Makes CARD_BRANDS Enums read-only.
   */
  get CARD_BRANDS() {
    return CARD_BRANDS;
  }
  /**
   * Makes CARD_TYPES Enums read-only.
   */
  get CARD_TYPES() {
    return CARD_TYPES;
  }
}

export default new CardBrandClass();
